import React from "react";
import "../Styles/Homepage.css";


import bhadrakali from "../Assests/bhad2-removebg-preview.png";

function Homepage() {
  return (
    <div className="homepage">

      {/* Hero Section */}
      <section className="hero-section">
       {/* <img src={hero} alt="Temple" className="hero-image" />*/}

        <div className="hero-overlay">
          
         

        
        </div>
      </section>

      {/* Today's Poojas */}
      <div className="container mt-5">

        <h2 className="section-title">Today's Poojas</h2>

        <div className="row">

          <div className="col-lg-4 col-md-6 mb-4">

            <div className="card pooja-card">

              <div className="card-body">

                <h4>Ganapathy Homam</h4>

                <p>Morning : 6:00 AM</p>

                <button className="btn btn-danger">
                  Book Now
                </button>

              </div>

            </div>

          </div>

          <div className="col-lg-4 col-md-6 mb-4">

            <div className="card pooja-card">

              <div className="card-body">

                <h4>Bhagavathy Pooja</h4>

                <p>Morning : 8:00 AM</p>

                <button className="btn btn-danger">
                  Book Now
                </button>

              </div>

            </div>

          </div>

          <div className="col-lg-4 col-md-6 mb-4">

            <div className="card pooja-card">

              <div className="card-body">

                <h4>Saraswathy Pooja</h4>

                <p>Evening : 6:00 PM</p>

                <button className="btn btn-danger">
                  Book Now
                </button>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* Festivals */}

      <div className="container mt-5">

        <h2 className="section-title">

          Upcoming Festivals

        </h2>

        <div className="row">

          <div className="col-md-6">

            <div className="festival-box">

              <h4>Navaratri</h4>

              <p>October 2026</p>

            </div>

          </div>

          <div className="col-md-6">

            <div className="festival-box">

              <h4>Krishna Jayanthi</h4>

              <p>September 2026</p>

            </div>

          </div>

        </div>

      </div>

      {/* Timings */}

      <div className="container mt-5">

        <div className="timing-box">

          <h2>Temple Timings</h2>

          <h5>Morning</h5>

          <p>5:00 AM - 11:00 AM</p>

          <h5>Evening</h5>

          <p>5:00 PM - 8:30 PM</p>

        </div>

      </div>

      {/* Donation */}

      <div className="container mt-5">

        <div className="donation-box">

          <h2>Support Our Temple</h2>

          <p>
            Your contribution helps preserve our traditions.
          </p>

          <button className="btn btn-warning">

            Donate Now

          </button>

        </div>

      </div>

      {/* Gallery */}

      <div className="container mt-5">

        <h2 className="section-title">

          Gallery

        </h2>

        <div className="row">

          <div className="col-lg-3 col-md-6 mb-4">

            <img
              src={bhadrakali}
              className="gallery-image"
              alt=""
            />

          </div>

          <div className="col-lg-3 col-md-6 mb-4">

            <img
              src={bhadrakali}
              className="gallery-image"
              alt=""
            />

          </div>

          <div className="col-lg-3 col-md-6 mb-4">

            <img
              src={bhadrakali}
              className="gallery-image"
              alt=""
            />

          </div>

          <div className="col-lg-3 col-md-6 mb-4">

            <img
              src={bhadrakali}
              className="gallery-image"
              alt=""
            />

          </div>

        </div>

      </div>

      {/* Footer */}

      <footer className="footer mt-5">

        <div className="container text-center">

          <h3>Sree Bhadrakali Temple</h3>

          <p>

            Temple Road, Kerala

          </p>

          <p>

            Phone : +91 9876543210

          </p>

          <p>

            Email : temple@gmail.com

          </p>

          <hr />

          <p>

            © 2026 All Rights Reserved

          </p>

        </div>

      </footer>

    </div>
  );
}

export default Homepage;